export default class FeedbackOptionSelector {
    rootElement: HTMLElement;
    inputElement: HTMLInputElement;
    
    constructor(uniqueID: string, inputID: string) {
        this.rootElement = document.getElementById(uniqueID) as HTMLElement;
        this.inputElement = this.rootElement?.querySelector<HTMLInputElement>(`#${inputID}`);

        if (this.inputElement) this.initialise();

    }

    private initialise() {
        const radioButtons = this.rootElement.querySelectorAll<HTMLInputElement>("input[type='radio']");

        radioButtons?.forEach(radio => {
            radio.addEventListener('change', () => {
                if (radio.checked) {
                    this.updateHiddenInput(radio.value);
                }
            });
        });
    }

    private updateHiddenInput(value: string) {
        if (this.inputElement) {
            this.inputElement.value = value;
            this.inputElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
}
